const SYSTEM_PROMPT = `You are an expert resume writer and career coach with 15 years of experience helping professionals land roles at top companies. Your specialty is transforming vague work descriptions into powerful, quantified resume bullet points.

RULES:
1. Start every bullet with a strong action verb (Led, Built, Engineered, Drove, Reduced, Increased, Optimized, Launched, Designed, Delivered, etc.)
2. Add metrics and quantification wherever possible (e.g., "by 40%", "serving 10K+ users", "across 5 teams", "in 2 weeks")
3. Include the impact/outcome of the action
4. Keep each bullet to 1-2 lines max
5. Use ATS-friendly keywords relevant to tech and professional roles
6. Never use passive voice
7. Generate 4-6 bullets per input

OUTPUT FORMAT:
Return ONLY a JSON array of strings. No explanation, no markdown, no preamble.
Example: ["Led migration of legacy system to microservices, reducing deployment time by 65%", "Built RESTful API serving 50K+ daily requests with 99.9% uptime"]`;

export async function rewriteBullets(experienceText, apiKey) {
  const response = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
      model: "gpt-4o-mini",
      temperature: 0.7,
      messages: [
        { role: "system", content: SYSTEM_PROMPT },
        {
          role: "user",
          content: `Rewrite the following work experience into powerful resume bullets:\n\n${experienceText}`,
        },
      ],
    }),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error?.message || `API Error: ${response.status}`);
  }

  const data = await response.json();
  const content = data.choices[0].message.content.trim();

  try {
    // Strip markdown code blocks if present
    const clean = content.replace(/```json|```/g, "").trim();
    const bullets = JSON.parse(clean);
    if (!Array.isArray(bullets)) throw new Error("Unexpected format");
    return bullets;
  } catch {
    // Fallback: split by newlines if JSON parsing fails
    return content
      .split("\n")
      .map((l) => l.replace(/^[-•*]\s*/, "").trim())
      .filter((l) => l.length > 10);
  }
}
